import Game from "../../Game.js";
import BasicAI from "./ai/BasicAI.js";
import Mob from "./Mob.js";
import StandardSheetAnimations from "./StandardSheetAnimations.js";

export default class Hero extends Mob {
	constructor(sprites) {
		super(sprites, StandardSheetAnimations.getAnimation("hero"));




		this.width = Game.HERO_WIDTH;
		this.height = Game.HERO_HEIGHT;

		let traits = {
			clas: "hero",
			race: "hero",
			name: "Hero",
			openDoors: true,
			static: false,
			qi: BasicAI.QI_PLAYER,
			speed: Hero.WALK_STEP * Game.MULT,
			radius: Hero.RADIUS,
			runspeed: Hero.RUN_STEP * Game.MULT,
			timeWarns: Hero.TIME_WARNS
		}
		this.setMobTraits(traits)
	}

	init() {
		this.mc = jQuery("#template-hero").clone();
		this.mc.attr("id", "mob" + Mob.ENUM++);
		this.mc.css({
			width: this.width,
			height: this.height,
		});

		this.initSprites();

	}

}

Hero.RADIUS = 4;
Hero.RADIUS_WITH_LANTERN = 8;
Hero.WALK_STEP = 4;
Hero.RUN_STEP = 6;
Hero.TIME_WARNS = [500, 1000];
